export default {
  site_name: '桃桃漫画网',
  site_tagline: '韩国漫画无删减下拉式-免费韩漫在线阅读',
  site_description: '桃桃漫画网提供韩国漫画无删减下拉式服务，免费可爱风韩漫在线阅读资源多样，下拉操作轻松，让您免费畅享无删减韩国可爱漫画的内容。',
  nav_home: '首页',
  nav_category: '分类',
  nav_about: '关于我们',
  nav_search: '搜索',
  hero_title_line1: '韩国漫画',
  hero_title_line2: '无删减下拉式',
  hero_title_line3: '免费在线阅读',
  hero_subtitle: '可爱风格韩漫 · 每日更新 · 畅快下拉体验',
  hero_cta: '开始阅读',
  hot_series: '热门',
  hot_ongoing: '连载',
  hot_realtime: '实时更新',
  editor_picks: '编辑精选',
  editor_daily: '每日推荐',
  cta_title: '加入桃桃漫画',
  cta_subtitle: '订阅追更通知，不错过任何精彩更新',
  cta_button: '立即订阅',
  footer_brand_title_line1: '桃桃',
  footer_brand_title_line2: '漫画网',
  footer_brand_desc: '桃桃漫画网致力于为读者提供最优质的韩国漫画阅读体验，无删减、免费、下拉式，让阅读更轻松。',
  footer_subscribe_label: '订阅追更通知',
  footer_subscribe_placeholder: '输入您的邮箱',
  footer_subscribe_btn: '订阅',
  footer_col_1_title: '快速链接',
  footer_col_2_title: '漫画分类',
  footer_col_3_title: '关于我们',
  footer_link_home: '首页',
  footer_link_category: '分类浏览',
  footer_link_about: '关于桃桃',
  footer_link_contact: '联系我们',
  footer_link_romance: '恋爱漫画',
  footer_link_fantasy: '奇幻漫画',
  footer_link_campus: '校园漫画',
  footer_link_action: '动作漫画',
  footer_link_thriller: '悬疑漫画',
  footer_link_comedy: '搞笑漫画',
  footer_copyright: '© 2026 桃桃漫画网 版权所有',
  breadcrumb_home: '首页',
  breadcrumb_category: '分类',
  read_more: '了解更多',
  start_reading: '开始阅读',
  subscribe: '订阅',
  loading: '加载中...',
  no_more: '没有更多了',
  back_to_home: '返回首页',
  page_not_found: '页面未找到',
  page_not_found_desc: '您访问的页面不存在或已被移除',
  category_title: '漫画分类',
  category_subtitle: '探索你喜欢的漫画类型',
  category_all: '全部',
  category_romance: '恋爱',
  category_fantasy: '奇幻',
  category_campus: '校园',
  category_action: '动作',
  category_thriller: '悬疑',
  category_comedy: '搞笑',
  comic_author: '作者',
  comic_status: '状态',
  comic_update: '更新至',
  comic_chapters: '话',
  status_ongoing: '连载中',
  status_completed: '已完结',
  about_title: '关于桃桃',
  about_subtitle: '品牌故事 · 发展愿景',
  about_description: '桃桃漫画网诞生于对韩国漫画的热爱。我们致力于打造一个纯净、友好的漫画阅读空间，让每一位读者都能享受到无删减、高质量的下拉式漫画阅读体验。从最初的小众平台到如今汇聚海量韩漫资源，桃桃始终秉持"免费、完整、优质"的服务理念。',
  about_vision: '我们的愿景是成为华语地区最受欢迎的韩漫阅读平台，让更多读者发现并爱上韩国漫画的独特魅力。',
  milestone_title: '品牌荣誉 / 成长里程碑',
  milestone_1_year: '2023',
  milestone_1_title: '平台创立',
  milestone_1_desc: '桃桃漫画网正式上线，首批引入200+部韩漫作品',
  milestone_2_year: '2024',
  milestone_2_title: '百万用户',
  milestone_2_desc: '注册用户突破100万，日活跃读者超过30万',
  milestone_3_year: '2025',
  milestone_3_title: '内容升级',
  milestone_3_desc: '漫画库扩展至5000+部，全面支持无删减下拉式阅读',
  milestone_4_year: '2026',
  milestone_4_title: '行业领先',
  milestone_4_desc: '成为华语地区领先的韩漫阅读平台，持续优化阅读体验',
  testimonial_title: '用户口碑',
  testimonial_rating: '9.9',
  testimonial_text: '"桃桃漫画网的阅读体验真的太棒了！下拉式操作超级顺滑，画质清晰，而且真的是无删减版本。每天通勤路上必刷，已经推荐给身边所有喜欢韩漫的朋友了！"',
  testimonial_user: '小桃酱',
  testimonial_role: '资深读者 · 3年忠实用户',
  contact_title: '联系我们',
  contact_subtitle: '有任何问题或建议？我们随时为您服务',
  contact_email: '联系邮箱：hello@taotao-comic.com',
  contact_address: '地址：上海市浦东新区张江高科技园区漫画大厦 18 层',
  contact_qq: '客服QQ：1234567890',
  prev: '上一条',
  next: '下一条',
  guess_you_like: '猜你喜欢',
  collect_comic: '收藏这本漫画',
  search_placeholder: '搜索漫画...',
  no_result: '暂无相关内容',
  weekly_new: '本周新作',
  early_access: '抢先连载',
  not_found_prompt: '没找到喜欢的？',
  not_found_subtitle: '试试浏览其他分类，总有适合你的',
  view_all: '查看全部',
};